import ExpertProfileSkillsAndExpertiseComponent from './expert-profile-skills-and-expertise.component'

const ExpertProfileSkillsAndExpertiseModule = angular.module('cdbl.expert-profile-skills-and-expertise', [

])
  .component('cdblExpertProfileSkillsAndExpertise', ExpertProfileSkillsAndExpertiseComponent)
  .name

export default ExpertProfileSkillsAndExpertiseModule
